import { cn } from '@/lib'

interface SkeletonProps {
  rows?: number
  className?: string
  children?: React.ReactNode
}

/**
 * Loading skeleton primitive.
 *
 * Default mode (no children): renders `rows` dark-card placeholder rows.
 * Composition mode (children provided): wraps children in an animate-pulse div.
 */
export default function Skeleton({ rows = 3, className, children }: SkeletonProps) {
  if (children !== undefined) {
    return <div className={cn('animate-pulse', className)}>{children}</div>
  }

  return (
    <div className={cn('space-y-4', className)}>
      {Array.from({ length: rows }).map((_, i) => (
        <div
          key={i}
          className="animate-pulse rounded-2xl border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-slate-900/70 p-6"
        >
          <div className="flex items-start justify-between gap-4">
            <div className="flex-1 space-y-3">
              <div className="h-3 w-20 rounded-full bg-gray-200 dark:bg-slate-700" />
              <div className="h-4 w-2/5 rounded-full bg-gray-200 dark:bg-slate-700" />
              <div className="h-3 w-1/3 rounded-full bg-gray-200 dark:bg-slate-700" />
            </div>
            <div className="flex gap-2">
              <div className="h-8 w-16 rounded-xl bg-gray-200 dark:bg-slate-700" />
              <div className="h-8 w-20 rounded-xl bg-gray-200 dark:bg-slate-700" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
